<template>
  <thead class="bg-gray-50">
    <tr>
      <th />
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-full"
      >
        Name
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap"
      >
        <svg
          v-if="primaryCriteria === 'email_address'"
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4 inline-block mr-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
          />
        </svg>
        <a href="#" @click.prevent="$emit('change-primary-criteria', 'email_address')"
          >Email address</a
        >
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap"
      >
        <svg
          v-if="primaryCriteria === 'phone_number'"
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4 inline-block mr-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
          />
        </svg>
        <a href="#" @click.prevent="$emit('change-primary-criteria', 'phone_number')"
          >Phone number</a
        >
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        Created
      </th>
    </tr>
  </thead>
</template>

<script>
export default {
  props: {
    primaryCriteria: {
      type: String,
      default: '',
    },
  },
};
</script>
